import React from "react";
import classes from "./ApplicationRequirements.module.scss";
import CustomImage from "../../CustomImage";

interface ApplicationRequirementsProps {
  countryData?: any;
}

const ApplicationRequirements: React.FC<ApplicationRequirementsProps> = ({ countryData }) => {
  const requirementsData = countryData?.requirements ?? [];

  return (
    <section id="application" className={classes["ar-section"]}>
      <div className={classes["ar-container"]}>
        <h2 className={classes["ar-heading"]}>{requirementsData?.title ?? ""}</h2>
        <div className={classes["ar-subtext"]} dangerouslySetInnerHTML={{ __html: requirementsData?.description ?? "" }}></div>
        <div className={classes["ar-grid"]}>
          {requirementsData?.applicationRequirements?.map((req: any) => (
            <div key={req.id} className={classes["ar-card"]}>
              <div className={classes["ar-card__icon"]}>
                <CustomImage src={req.icon?.url ?? "/images/default-application-requirement-icon.jpg"} alt={req.title} width={32} height={32} />
              </div>
              <div className={classes["ar-card__content"]}>
                <h3 className={classes["ar-card__title"]}>{req.title}</h3>
                <div className={classes["ar-card__desc"]} dangerouslySetInnerHTML={{ __html: req?.description ?? "" }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationRequirements;
